<template> 
  <div class="listitem">
    <dl>
        <dd><img :src="item.pic" /></dd>
        <dt>
          <div class="top">
            <h2 :title="item.newsTitle">{{ item.newsTitle }}</h2>
            <div class="line"></div>
            <p :title="item.description">{{ item.description }}</p>
          </div>
          <div class="more_box">
            <p><i class="el-icon-arrow-right"></i> Read More...</p>
          </div>
        </dt>
    </dl>
    <el-divider></el-divider>
  </div>
</template>

<script>
export default {
    props: {
      item: {
        default() {
          return {
            pic: '',
            newsTitle: '标题',
            description: '描述'
          }
        },
        type: Object 
        }
    },
    created() {
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
.listitem{
  color: #333;
  dl {
    height: 265px;
    display: flex;
    justify-self: space-between;
    transition: .6s;
    border-radius: 4px;
    overflow: hidden;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      width: calc(100% - 20px);
      height: 150px;
      margin-bottom: 20px;
      padding: 0 10px;
      box-sizing: content-box;
    }
    &:hover {
      box-shadow: 4px 20px 40px 5px rgba(0, 0, 0, 0.1);
      /* 盒子向上移动效果，改变上外边距 */
      margin-top: -4px;
      transition: .6s;
    }
    dd {
      width: 265px;
      height: 265px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      @media screen and (min-width: 300px) and (max-width: 768px) {
        width: 120px;
        height: 120px;
        overflow: hidden;
      }
      img {
        height: 265px;
        transition: all 0.6s;
        @media screen and (min-width: 300px) and (max-width: 768px) {
          width: 120px;
          height: 120px;
          transition: all 0.6s;
        }
        &:hover {
          transform: scale(1.1);
          cursor: pointer;
        }
      }
    }
    dt {
      flex: 1;
      padding: 10px 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
      @media screen and (min-width: 300px) and (max-width: 768px) {
        padding: 0 0 0 10px;
      }
      .top {
        h2 {
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;

          @media screen and (min-width: 300px) and (max-width: 768px) {
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          &:hover {
            color: #1a46a7;
          }
        }
        .line {
          width: 50px;
          height: 1px;
          background: #ccc;
          margin: 20px 0 10px 0;
          opacity: 0.6;
          @media screen and (min-width: 300px) and (max-width: 768px) {
            margin: 10px 0 0px 0;
          }
        }
        p {
          font-size: 14px;
          opacity: 0.6;
          margin-top: 10px;
          line-height: 2;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 0;
          &:hover {
            color: #26a3de;
          }
        }
      }
      .more_box {
        cursor: pointer;
        p {
          font-size: 14px;
          color: #333;
          &:hover {
            color: #26a3de;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/view/components/listItem.vue